class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/// --- NIF no carrinho lateral ---
document.addEventListener('DOMContentLoaded', function () {
  var cartForm = document.querySelector('#CartDrawer-Form');
  var nifInput = document.querySelector('#DrawerNif');

  if (cartForm) cartForm.setAttribute('novalidate', true);

  if (!cartForm || !nifInput) return;

  // 🇦🇴 Validação NIF Angola (10 dígitos começando com 5, 8 ou 9)
  function validarNIF_Angola(nif) {
    return /^[589]\d{9}$/.test(nif);
  }

  // 🇵🇹 Validação NIF Portugal (9 dígitos + verificação do dígito de controlo)
  function validarNIF_Portugal(nif) {
    if (!/^\d{9}$/.test(nif)) return false;

    var digits = nif.split('').map(Number);
    var total = 0;

    for (var i = 0; i < 8; i++) {
      total += digits[i] * (9 - i);
    }

    var checkDigit = 11 - (total % 11);
    if (checkDigit >= 10) checkDigit = 0;

    return checkDigit === digits[8];
  }

  // Função geral
  function validarNIF(nif) {
    nif = nif.trim();

    // Campo vazio → válido (não obrigatório)
    if (nif === '') return true;

    // PT
    if (nif.length === 9 && validarNIF_Portugal(nif)) return true;

    // AO
    if (nif.length === 10 && validarNIF_Angola(nif)) return true;

    return false;
  }

  cartForm.addEventListener('submit', function (e) {
    var nifValue = nifInput.value.trim();

    // ⛔ Só valida se o cliente preencheu
    if (!validarNIF(nifValue)) {
      e.preventDefault();
      alert('Por favor, insira um NIF válido:\n- Angola: 10 dígitos (começa por 5, 8 ou 9)\n- Portugal: 9 dígitos com controlo');
      nifInput.focus();
      return false;
    }

    // Remove note duplicado
    var existingNote = cartForm.querySelector('input[name="note"]');
    if (existingNote) existingNote.remove();

    // Se o cliente não inseriu NIF → não envia nada
    if (nifValue === '') return;

    // Para Vendus: enviar apenas o número limpo
    var noteInput = document.createElement('input');
    noteInput.type = 'hidden';
    noteInput.name = 'note';
    noteInput.value = nifValue;

    cartForm.appendChild(noteInput);
  });
});
